import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";
import IndexTypeGroupMapper from "../service/IndexTypeGroupMapper";
import IndexTypeGroupParamMapper from "../service/IndexTypeGroupParamMapper";

export default class UpdateIndexGroupTypeInteractor {
  private updateResource: UpdateResourceInteractor<IIndexTypeGroup>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IIndexTypeGroup) {
    return this.updateResource.execute(
      Constants.indexGroupBasePath,
      IndexTypeGroupMapper,
      IndexTypeGroupParamMapper,
      model,
      model.id
    );
  }
}
